<template>
  <div class="related-posts" v-if="relatedBlogs && relatedBlogs.length">
    <h3 class="related-title">Related articles</h3>
    <div class="related-grid">
      <div
        v-for="relatedBlog in relatedBlogs"
        :key="relatedBlog.id"
        class="related-card"
        @click="navigateToBlog(relatedBlog.id)"
      >
        <div class="related-image-container" v-if="relatedBlog.image">
          <img
            :src="relatedBlog.image"
            :alt="`${relatedBlog.title} image`"
            class="related-image"
          />
        </div>
        <div class="related-content">
          <h4 class="related-blog-title">{{ relatedBlog.title }}</h4>
          <span class="related-date">{{ relatedBlog.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RelatedArticles",
  props: {
    relatedBlogs: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    navigateToBlog(blogId) {
      this.$emit("navigate-to-blog", blogId);
    },
  },
};
</script>

<style scoped>
.related-posts {
  margin-bottom: 3rem;
}

.related-title {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #000;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-weight: 600;
}

.related-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.related-card {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: #fff;
}

.related-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.related-image-container {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.related-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0.5rem;
}

.related-content {
  padding: 1rem;
}

.related-blog-title {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #000;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-weight: 600;
  line-height: 1.3;
}

.related-date {
  font-size: 0.8rem;
  color: #666;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
}

@media (max-width: 768px) {
  .related-grid {
    grid-template-columns: 1fr;
  }
}
</style>
